var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5 pt-5"},[(_vm.errrr)?_c('img',{staticStyle:{"height":"50vh"},attrs:{"src":require("../../assets/images/400.svg"),"alt":""}}):_c('ProgressSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }